export function formatPercent(percent: number, ignoreSign: boolean = false) {
  const isWholeNumber = (percent % 1) === 0;

  if (isWholeNumber) {
    return `${percent.toFixed(0)}${ignoreSign ? '' : '%'}`;
  }
  return `${percent.toFixed(2)}${ignoreSign ? '' : '%'}`;
}
